import { CalendarTimeInterval } from './utils';
/**
 * Výška hodiny v pixelech - pro jednotlivé typy zobrazení 10, 15, 30 a 60 minut.
 */
export const CALENDAR_ITEM_HEIGHTS = {
  [CalendarTimeInterval.TEN]: 168,
  [CalendarTimeInterval.FIFTEEN]: 110,
  [CalendarTimeInterval.THIRTY]: 68,
  [CalendarTimeInterval.SIXTY]: 64,
};

export enum EventSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  FULL = 'full',
}

/**
 * Maximální výšky daného typu (v px), pokud se element nevejde do dané výšky, je použita vyšší
 * SMALL > MEDIUM > FULL
 */
export const CALENDAR_EVENTSIZE_LIMITS = {
  [EventSize.SMALL]: 35,
  [EventSize.MEDIUM]: 60,
};

export const MOUSE_MOVE_VECTOR = 4;

export const HOUR_COLUMN_ITEM_LINE_HEIGHT = 14;
export const EVENT_VERTICAL_MARGIN = 4;
export const RIGHT_COLUMN_SPACE = 14;
export const GLOBAL_SETTINGS_CALENDAR_VIEW_KEY =
  'globalSettings.calendars.calendarView';

export const CALENDAR_EVENT_MIN_HEIGHT = 16;
